import React from 'react'

function About() {
    return (
        <div>
            <h1>This is a github Finder App</h1>
            <h2>Created By: Yamini Shrestha</h2>
        </div>
    )
}

export default About;
